<template>
    <div>
        <home-header page-name="各種設定" :istop="true"> </home-header>
        <home-list></home-list>
    </div>
</template>

<script>
    import HomeHeader from 'pages/commons/header/Header'
    import HomeList from './components/List'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            HomeHeader,
            HomeList,
        },
    }
</script>

<style></style>
